<template>
  <component
    :is="dialog ? 'q-dialog' : 'div'"
    v-if="shown"
    v-model="shown"
    :maximized="dialog"
    data-test-id="rewards-dialog"
  >
    <q-card
      :class="{
        'bg-transparent no-shadow': !dialog,
        'scroll': dialog
      }"
      :style="{
        width: $q.screen.lt.sm || !dialog ? '100%' : '90%',
        height: $q.screen.lt.sm || !dialog ? undefined : '90%'
      }"
    >
      <div
        v-if="dialog"
        class="row items-start justify-start q-gutter-sm q-pa-md"
        :class="{
          'fixed sticky-fixed-bar full-width': fixedPosition,
          'bg-grey-10': $q.dark.isActive && fixedPosition,
          'bg-white': !$q.dark.isActive && fixedPosition
        }"
      >
        <div
          v-if="currentSite.rewardCurrencyImageUrl"
          class="col-auto q-my-auto"
          style="max-height: 75px;"
          :style="{
            width: fixedPosition ? '20%' : '25%',
            'max-width': $q.screen.gt.xs ? '120px' : undefined
          }"
        >
          <q-img
            :src="currentSite.rewardCurrencyImageUrl"
          />
        </div>

        <div
          class="col-auto"
        >
          <div
            class="text-h4"
            :class="fixedPosition ? 'text-h5' : 'text-h4'"
          >
            {{ `${order.availablePoints} ${currentCircuit.rewardsCurrencyName}` }}
          </div>
          <div
            v-if="!fixedPosition"
            class="text-h6"
          >
            {{ $t(`membership.availableToUsePrompt`) }}
          </div>
        </div>
        <q-space />
        <q-btn
          v-close-popup
          class="justify-end"
          icon="close"
          flat
          round
          dense
        />
      </div>
      <q-scroll-observer @scroll="onScroll" />
      <q-card-section
        v-for="voucherCost in $_.keys(voucherTypeGroups)"
        :key="voucherCost"
        class="q-pa-none"
      >
        <template
          v-if="voucherTypeGroups[voucherCost].redeemableItems.length || voucherTypeGroups[voucherCost].redeemableItemVariations.length"
        >
          <div
            class="text-h6 q-px-md border-bottom"
            :style="{ opacity: userHasEnoughPoints(voucherCost) ? '100%' : '30%' }"
          >
            {{ `${voucherCost} ${currentCircuit.rewardsCurrencyName}` }}
          </div>
          <div
            v-if="!$register && !dialog && $q.screen.gt.xs"
            class="q-py-md"
            :class="$q.screen.lt.sm || !$isLandscapeView() ? 'q-pl-md' : undefined"
          >
            <swiper
              class="swiper"
              :modules="[Navigation]"
              :navigation="{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }"
              :slides-per-view="'auto'"
              :space-between="10"
            >
              <swiper-slide
                v-for="category in voucherTypeGroups[voucherCost].categories"
                :key="category.id"
                style="height: auto;"
                :style="{ 'max-width': $q.screen.lt.sm ? '120px' : '140px' }"
              >
                <div
                  class="wrapper"
                  style="height: 100%;"
                >
                  <q-card
                    class="column cursor-pointer"
                    :class="{
                      'bg-primary active': isActive === category && pointsCost === voucherCost,
                      'text-white': isActive === category && pointsCost === voucherCost && $isColorDark(currentSite.primaryColor),
                      'text-dark': isActive === category && pointsCost === voucherCost && !$isColorDark(currentSite.primaryColor),
                      'justify-center': !category.imageUrl,
                    }"
                    style="min-height: 50px; height: calc(100% - 10px);"
                    :style="{ width: $q.screen.lt.sm ? '110px' : '140px' }"
                    :disabled="!userHasEnoughPoints(voucherCost)"
                    flat
                    bordered
                    clickable
                    @click="handleCategoryClick(category, voucherTypeGroups[voucherCost].redeemableItems, voucherTypeGroups[voucherCost].voucherTypes, voucherCost, true)"
                  >
                    <q-img
                      v-if="!!category.imageUrl"
                      :src="category.imageUrl"
                    />

                    <q-card-section class="q-pa-xs">
                      <div class="text-body2 text-center text-weight-bolder">
                        {{ category.name }}
                      </div>
                    </q-card-section>
                  </q-card>
                </div>
              </swiper-slide>
              <swiper-slide
                v-for="item in voucherTypeGroups[voucherCost].miscellaneousItems"
                :key="item.id"
                style="height: auto;"
                :style="{ width: $q.screen.lt.sm ? '120px' : '140px' }"
              >
                <div
                  class="wrapper"
                  style="height: 100%;"
                >
                  <item-card
                    :item-width="$q.screen.lt.sm ? '110px' : '140px'"
                    :item="item"
                    :order="order"
                    :display-price="false"
                    :disabled="!userHasEnoughPoints(voucherCost)"
                    :has-alcohol-acknowledgement="!!item.showAlcoholAcknowledgement"
                    text-center
                    @click="adminApproved => handleItemClick(item, voucherCost, voucherTypeGroups[voucherCost].voucherTypes, adminApproved)"
                  />
                </div>
              </swiper-slide>
              <swiper-slide
                v-for="item in voucherTypeGroups[voucherCost].miscellaneousVariations"
                :key="item.itemVariation.id"
                style="height: auto;"
                :style="{ width: $q.screen.lt.sm ? '120px' : '140px' }"
              >
                <item-card
                  :item-width="$q.screen.lt.sm ? '110px' : '140px'"
                  :item="item.itemVariation.item"
                  :item-name="`${item.itemVariation.name} ${item.itemVariation.item.name}`"
                  :order="order"
                  :display-price="false"
                  :disabled="!userHasEnoughPoints(voucherCost)"
                  :has-alcohol-acknowledgement="!!item.showAlcoholAcknowledgement"
                  text-center
                  @click="applyVoucher(item)"
                />
                <div
                  class="wrapper"
                  style="height: 100%;"
                />
              </swiper-slide>
              <div
                class="swiper-button-prev bg-primary shadow-5"
                :class="$isColorDark(currentSite.primaryColor) ? 'text-white' : 'text-dark'"
                style="left: 0"
              />
              <div
                class="swiper-button-next bg-primary shadow-5"
                :class="$isColorDark(currentSite.primaryColor) ? 'text-white' : 'text-dark'"
                style="right: 0"
              />
            </swiper>
            <category-dialog
              :ref="`categoryDialog${voucherCost}`"
              :order="order"
              :dialog="dialog"
            >
              <template #title>
                <div />
              </template>
              <template #items>
                <div class="row q-gutter-md content-start justify-start scroll">
                  <item-card
                    v-for="item in categoryItems"
                    :key="item.id"
                    :item-width="itemWidth"
                    :item="item"
                    :order="order"
                    :display-price="false"
                    :disabled="!userHasEnoughPoints(voucherCost)"
                    @click="adminApproved => handleItemClick(item, pointsCost, selectedVoucherTypes, adminApproved)"
                  />
                </div>
              </template>
            </category-dialog>
          </div>
          <div
            v-else
            class="q-py-md row q-gutter-md content-start scroll"
            :class="{
              'justify-between': $q.screen.lt.sm,
              'q-px-md': dialog,
              'q-px-sm': !dialog,
              'justify-start': $q.screen.gt.xs,
            }"
          >
            <item-card
              v-for="category in voucherTypeGroups[voucherCost].categories"
              :key="category.id"
              :item-width="$q.screen.lt.sm ? '45%' : '200px'"
              :item="category"
              :item-name="category.name"
              :order="order"
              :display-price="false"
              :disabled="!userHasEnoughPoints(voucherCost)"
              text-center
              @click="handleCategoryClick(category, voucherTypeGroups[voucherCost].redeemableItems, voucherTypeGroups[voucherCost].voucherTypes, voucherCost)"
            />
            <item-card
              v-for="item in voucherTypeGroups[voucherCost].miscellaneousItems"
              :key="item.id"
              :item-width="$q.screen.lt.sm ? '45%' : '200px'"
              :item="item"
              :order="order"
              :display-price="false"
              :disabled="!userHasEnoughPoints(voucherCost)"
              :has-alcohol-acknowledgement="!!item.showAlcoholAcknowledgement"
              text-center
              @click="adminApproved => handleItemClick(item, voucherCost, voucherTypeGroups[voucherCost].voucherTypes, adminApproved)"
            />

            <item-card
              v-for="item in voucherTypeGroups[voucherCost].miscellaneousVariations"
              :key="item.id"
              :item-width="$q.screen.lt.sm ? '45%' : '200px'"
              :item="item.itemVariation.item"
              :item-name="`${item.itemVariation.name} ${item.itemVariation.item.name}`"
              :order="order"
              :display-price="false"
              :disabled="!userHasEnoughPoints(voucherCost)"
              :has-alcohol-acknowledgement="!!item.itemVariation.item.showAlcoholAcknowledgement"
              text-center
              @click="applyVoucher(item)"
            />
          </div>
        </template>
      </q-card-section>
    </q-card>
    <category-dialog
      v-if="selectedCategory"
      ref="categoryDialog"
      :order="order"
      :dialog="$q.screen.lt.sm || dialog"
      :available-online="availableOnline"
    >
      <template #title>
        {{ `${selectedCategory.name}-${pointsCost} ${(currentCircuit.rewardsCurrencyName || 'Points')}` }}
      </template>
      <template #items>
        <div class="row q-gutter-md content-start justify-start scroll">
          <item-card
            v-for="item in categoryItems"
            :key="item.id"
            :item-width="itemWidth"
            :item="item"
            :order="order"
            :display-price="false"
            @click="adminApproved => handleItemClick(item, pointsCost, selectedVoucherTypes, adminApproved)"
          >
            <template #price />
          </item-card>
        </div>
      </template>
    </category-dialog>
    <rewards-order-item-form
      ref="rewardsOrderItemForm"
      :rewards-currency-name="currentCircuit.rewardsCurrencyName"
      :available-online="availableOnline"
      @add-model="orderItem => notifyAdded(orderItem.itemOrderItem.item)"
    />
  </component>
</template>

<script>
import { Notify } from 'quasar'
import ItemCard from 'src/modules/checkout/components/ItemCard'
import AvailableItemsMixin from 'src/modules/checkout/components/mixins/AvailableItemsMixin'
import MembershipVoucherTypesMixin from 'src/modules/checkout/components/mixins/MembershipVoucherTypesMixin'
import RewardsOrderItemForm from 'src/modules/checkout/components/RewardsOrderItemForm'
import CategoryDialog from 'src/modules/checkout/dialogs/CategoryDialog'
import SwiperModulesMixin from 'src/modules/consumer/components/mixins/SwiperModulesMixin'
import SalesRestrictionsMixin from 'src/modules/mixins/SalesRestrictionsMixin'

// This is a hacky fix to prevent the price calculation from causing a recursive loop by using unreactive cache object
const ITEM_PRICES_BY_ITEM_IDS = {}

function clearItemPriceCache () {
  _.each(ITEM_PRICES_BY_ITEM_IDS, (_value, key) => {
    delete ITEM_PRICES_BY_ITEM_IDS[key]
  })
}

export default {
  name: 'RewardsDialog',
  components: {
    CategoryDialog,
    ItemCard,
    RewardsOrderItemForm
  },
  mixins: [SalesRestrictionsMixin, SwiperModulesMixin, MembershipVoucherTypesMixin, AvailableItemsMixin],
  context: ['currentUser'],
  configuration: ['currentCircuit', 'currentSite', 'voucherTypes', 'items', 'itemVariations', 'deliveryLocations'],
  inject: ['order'],
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: true
    },
    availableOnline: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      pointsCost: null,
      selectedCategory: null,
      selectedVoucherTypes: [],
      redeemableItems: [],
      currentVoucher: null,
      isActive: false,
      fixedPosition: false
    }
  },
  computed: {
    categoryItems () {
      return _.filter(this.redeemableItems, (item) => item.categoryId === this.selectedCategory.id)
    },
    activeItems () {
      return _.filter(this.items.data, item => this.isItemAvailable(item))
    },
    allCategories () {
      const availableOnlineCategories = _.filter(this.currentCircuit.onlineCategories, category => {
        if (category.showingBadgeIds?.length && category.requireShowingBadges) {
          const showing = this.order.currentShowing || this.order.nextShowing
          if (!showing) {
            return !category.requireShowingBadges
          } else if (category.requireAllShowingBadges) {
            // If all category showing badges are required, then all of the category showing badges need to be present.
            // If showing badges are required, then the difference should be 0. If showings with all badges are excluded, then the difference must not be 0.
            // This is an AND operation.
            return category.requireShowingBadges === (_.difference(category.showingBadgeIds, showing.showingBadgeIds).length === 0)
          } else {
            // If not all category showing badges are required, then only one of the category showing badges needs to be present.
            // If showing badges are required, then the intersection should be above 0. If showings with any badges are excluded, then the intersection must be 0.
            // This is an OR operation.
            return category.requireShowingBadges === (_.intersection(category.showingBadgeIds, showing.showingBadgeIds).length > 0)
          }
        }
        return true
      })
      return availableOnlineCategories
    },
    voucherTypeGroups () {
      // We display redeemable item options grouped by voucher type cost,
      // so here we group vouchers by cost and get their associated items
      const voucherTypes = this.membershipVoucherTypes

      const voucherTypeGroups = _.groupBy(voucherTypes, 'pointsCost')
      const pointsCostGroups = {}
      _.each(voucherTypeGroups, (voucherTypes, cost) => {
        pointsCostGroups[cost] = { voucherTypes }
      })
      _.each(_.values(pointsCostGroups), group => this.getRedeemableItems(group))
      return pointsCostGroups
    },
    itemWidth () {
      if (this.$q.screen.lt.sm) {
        return '45%'
      } else if (this.$q.screen.lt.md) {
        return '22%'
      } else {
        return '18%'
      }
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  created () {
    clearItemPriceCache()
  },
  methods: {
    hide () {
      this.shown = false
    },
    show () {
      this.shown = true
    },
    onScroll (dialogHeader) {
      if (this.$q.screen.gt.xs) return
      if (dialogHeader.position > 90) {
        this.fixedPosition = true
      } else {
        this.fixedPosition = false
      }
    },
    closeCategoryDialogs () {
      _.each(_.keys(this.voucherTypeGroups), voucherCost => {
        if (this.$refs['categoryDialog' + voucherCost] && this.$refs['categoryDialog' + voucherCost].length) {
          this.$refs['categoryDialog' + voucherCost][0].hide()
        }
      })
    },
    handleCategoryClick (category, items, voucherTypeGroup, pointsCost, isNotDialog = false) {
      if (!this.userHasEnoughPoints(pointsCost)) return
      this.selectedCategory = category
      this.selectedVoucherTypes = voucherTypeGroup
      this.redeemableItems = items
      this.pointsCost = pointsCost
      if (isNotDialog) {
        this.closeCategoryDialogs()
        this.$refs['categoryDialog' + pointsCost][0].show(category)
      } else {
        this.$refs.categoryDialog.show(category)
      }
      this.isActive = category
    },
    handleItemClick (item, pointsCost, voucherTypeGroup) {
      if (!this.userHasEnoughPoints(pointsCost)) return
      this.pointsCost = pointsCost
      this.selectedVoucherTypes = voucherTypeGroup
      this.checkForSalesRestrictions({
        item,
        successCallback: (adminApproved) => {
          const orderItem = this.order.itemOrderItemForItem(item, null, null, adminApproved)
          // Skip showing detail on register since they can see the cart and can easily edit if needed
          if (item.skipDetailDialog) {
            this.order.orderItems.add(orderItem)
            // Multiple vouchers in the group could apply to the item. Need to make sure we find the one
            // that covers the largest price
            const voucherType = item.getBestVoucherForItem(voucherTypeGroup)
            this.order.applyReward(voucherType)
            this.notifyAdded(item)
          } else {
            orderItem.order = this.order
            this.$refs.rewardsOrderItemForm.show(orderItem, pointsCost, voucherTypeGroup, this.order)
          }
        }
      })
    },
    applyVoucher (variationAndVoucher) {
      if (!this.userHasEnoughPoints(variationAndVoucher.voucherType.pointsCost)) return
      const item = variationAndVoucher.itemVariation.item

      this.checkForSalesRestrictions({
        item,
        successCallback: (adminApproved = false) => {
          const orderItem = this.order.itemOrderItemForItem(item, variationAndVoucher.itemVariation, null, adminApproved)
          this.order.orderItems.add(orderItem)
          this.order.applyReward(variationAndVoucher.voucherType)
          this.notifyAdded(variationAndVoucher.itemVariation)
        }
      })
    },
    notifyAdded (item) {
      if (this.dialog) {
        this.shown = false // Close the dialog after adding the item to the cart
      }
      if (this.$register) return
      Notify.create({
        message: `${item.name} added to Cart`,
        type: 'positive',
        position: 'bottom',
        group: false,
        timeout: 2500,
        classes: 'added-to-cart-notif'
      })
    },
    getItemVariations (group) {
      const itemIds = {}
      let redeemableItemVariations = _.map(group.voucherTypes, voucherType => {
        if (voucherType.itemVariation && (!voucherType.hasMaxPrice || voucherType.maxPrice >= voucherType.itemVariation.price)) {
          const isAvailable = this.isItemAvailable(voucherType.itemVariation.item)
          if (isAvailable) {
            return {
              itemVariation: voucherType.itemVariation,
              voucherType
            }
          }
        }
      })
      // It's possible that multiple vouchers exist for the same item variation, but we only want
      // to display each item variation once
      redeemableItemVariations = _.compact(redeemableItemVariations)
      group.redeemableItemVariations = _.uniqBy(redeemableItemVariations, 'itemVariation.id')
      // If multiple variations of one item are present, we want to display the item instead of all
      // the separate variations. Here we distinguish miscellaneous variations from those who could be grouped
      _.each(group.redeemableItemVariations, voucherType => {
        itemIds[voucherType.itemVariation.itemId] ? itemIds[voucherType.itemVariation.itemId] = itemIds[voucherType.itemVariation.itemId] + 1 : itemIds[voucherType.itemVariation.itemId] = 1
      })
      _.each(_.keys(itemIds), itemId => {
        if (itemIds[itemId] > 1) {
          const item = _.find(this.activeItems, (i) => i.id === Number(itemId))
          if (item) {
            group.redeemableItems.push(item)
          }
        } else {
          const miscVariation = _.find(group.redeemableItemVariations, (iv) => iv.itemVariation.item.id === Number(itemId))
          if (miscVariation) {
            group.miscellaneousVariations.push(miscVariation)
          }
        }
      })
    },
    priceForItem (item) {
      // Calculating prices on each render causes a recursive loop, so we cache the prices
      // after calculating them once.
      if (!_.isNil(ITEM_PRICES_BY_ITEM_IDS[item.id])) return ITEM_PRICES_BY_ITEM_IDS[item.id]

      const orderItem = this.order.itemOrderItemForItem(item)
      const price = orderItem?.displayPrice || 0
      ITEM_PRICES_BY_ITEM_IDS[item.id] = price
      orderItem?.destroy()

      return price
    },
    getRedeemableItems (group) {
      group.redeemableItems = []
      group.categories = []
      group.miscellaneousItems = []
      group.miscellaneousVariations = []
      group.redeemableItemVariations = []
      const categoryIds = {}
      this.getItemVariations(group)
      _.each(group.voucherTypes, voucherType => {
        _.each(this.activeItems, item => {
          if (voucherType.type === 'item' && voucherType.isItem(item)) {
            if (!voucherType.hasMaxPrice || this.priceForItem(item) <= voucherType.maxPrice) {
              group.redeemableItems.push(item)
            }
          }
        })
      })
      // It's possible that multiple vouchers exist for the same item, but we only want
      // to display each item once
      group.redeemableItems = _.uniqBy(group.redeemableItems, 'id')
      // If multiple items from one category are present, we want to display the category instead of all
      // the separate items. Here we distinguish miscellaneous items from those who could be grouped
      _.each(group.redeemableItems, item => {
        if (item.categoryId) {
          categoryIds[item.categoryId] ? categoryIds[item.categoryId] = categoryIds[item.categoryId] + 1 : categoryIds[item.categoryId] = 1
        } else {
          group.miscellaneousItems.push(item)
        }
      })
      _.each(_.keys(categoryIds), catId => {
        if (categoryIds[catId] > 1) {
          const category = _.find(this.allCategories, (cat) => cat.id === Number(catId))
          if (category) {
            group.categories.push(category)
          }
        } else {
          const miscItem = _.find(group.redeemableItems, (item) => item.categoryId === Number(catId))
          if (miscItem) {
            group.miscellaneousItems.push(miscItem)
          }
        }
      })
      // if a variation's item appears in the redeemable items group, we want to exclude it from the misc variations
      group.miscellaneousVariations = _.reject(group.miscellaneousVariations, variation => _.find(group.redeemableItems, item => item.id === variation.itemVariation.itemId))
    },
    userHasEnoughPoints (pointsCost) {
      return pointsCost <= this.order.availablePoints
    }
  }
}
</script>

<style lang="scss" scoped>
.added-to-cart-notif {
  margin-bottom: 60px;
  margin-top: -50px;
}
.swiper-button-next:after, .swiper-button-prev:after{
  font-size: 18px;
}
.swiper-button-next, .swiper-button-prev{
  width: 36px;
  height: 36px;
  border-radius: 0px;
}
.swiper-button-disabled{
  display: none;
}
.active{
  position: relative;
  margin-bottom: 10px;
}
.active:before{
  display: block;
  content: "";
  height: calc(100% - 6px);
  width: calc(100% - 6px);
  border: 3px solid var(--q-primary);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.wrapper {
  margin-bottom: 10px;
}
.wrapper .active:after{
  content: "";
  border-left-width: 8px;
  border-left-style: solid;
  border-left-color: transparent;
  border-right-width: 8px;
  border-right-style: solid;
  border-right-color: transparent;
  border-top-width: 8px;
  border-top-style: solid;
  border-top-color: var(--q-primary);
  position: absolute;
  z-index: 2;
  bottom: -8px;
  left: 45%;
}

.border-primary-3{
  position: relative;
}
.border-primary-3:before{
  display: block;
  content: "";
  height: calc(100% - 6px);
  width: calc(100% - 6px);
  border: 3px solid var(--q-primary);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.sticky-fixed-bar {
  z-index: 1001;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  animation: goDown 0.3s ease-in-out forwards;
}

@keyframes goDown {
  0%{
    transform: translateY(-50px);
  }
  100% {
    transform: translateY(0px);
  }
}

.q-dialog__inner--maximized > div {
  // I have no idea why we need to do this, but the dialog doesn't doesn't
  // center vertically if we don't.
  width: unset;
}
</style>
